import { MobileFilterType, PackageStatus } from './enums/common.enums';
import { FilterOption, OnboardingStep } from './models/common.model';
import { PACKAGE_STATUS_META, statusOptions } from './utilities/status.meta';

export const ONBOARDING_KEY = 'ppu_onboarding_complete';

export const ONBOARDING_STEPS: OnboardingStep[] = [ 
  {
    title1Key: 'App.SplashScreen.Onboarding.Step1.Title1',
    title2Key: 'App.SplashScreen.Onboarding.Step1.Title2',
    title1Class: 'title-accent white',
    title2Class: 'title-accent secondary',
    backgroundClass: 'bg-step-1',
  },
  {
    title1Key: 'App.SplashScreen.Onboarding.Step2.Title1',
    title2Key: 'App.SplashScreen.Onboarding.Step2.Title2',
    title1Class: 'title-accent primary',
    title2Class: 'title-accent navy',
    backgroundClass: 'bg-step-2',
  },
  {
    title1Key: 'App.SplashScreen.Onboarding.Step3.Title1',
    title2Key: 'App.SplashScreen.Onboarding.Step3.Title2',
    title1Class: 'title-accent white',
    title2Class: 'title-accent white',
    backgroundClass: 'bg-step-3',
  },
];

export const PAY_PER_USE_CHARGE = 3.99;
export const PERSONAL_CHARGE = 8.99;
export const TERMS_URL = "https://penguinpickup.com/policies/terms-of-use";
export const PRIVACY_POLICY_URL = "https://penguinpickup.com/policies/privacy-policy";
export const CUSTOMER = 'Customer';
export const MODAL_ACTION_APPLY = 'Apply';
export const MODAL_ACTION_RESET = 'Reset';
export const MODAL_ACTION_CANCEL = 'Cancel';
export const MODAL_ACTION_CONFIRM = 'Confirm';
export const PAYMENT_PAY_AT_PICKUP = 'PayAtPickup';
export const PAYMENT_SUBSCRIPTION = 'Subscription';
export const PAYMENT_PAY_NOW = 'PayNow';
export const SKELETON_LOADER_MIN_DISPLAY_TIME = 500;
export const LOADER_MIN_DISPLAY_TIME = 300;
export const MIN_SEARCH_LENGTH = 3;

export const orderCourierOptions: FilterOption = {
  options: [
    { id: 1, value: 'Purolator' },
    { id: 3, value: 'FedEx' },
    { id: 5, value: 'DHL' },
    { id: 12, value: 'Canpar' },
    { id: 47, value: 'Nationex' },
    { id: 59, value: 'ICS Courier' },
    { id: 62, value: 'PickPack' },
    { id: 2, value: 'UPS' },
    { id: 4, value: 'Canada Post' },
    { id: 28, value: 'Amazon' },
    { id: 6, value: 'Other' },
  ],
  selected: [],
};

export const OrdersFilterConfig: Map<number, FilterOption> = new Map([
  [MobileFilterType.Courier, orderCourierOptions],
  [MobileFilterType.Status, {
    options: statusOptions(PACKAGE_STATUS_META).filter(
      option => option.id !== PackageStatus.PendingUnload
    ),
    selected: [],
  }],
  [MobileFilterType.ReceivedDateRange, { options: null, selected: [] }],
  [MobileFilterType.PickedDateRange, { options: null, selected: [] }],
]);

export const LOCATIONS_TOGGLE_OPTIONS: FilterOption = {
  options: [
    { id: 'openNow', value: 'App.FiltersDrawer.Filters.OpenNow' },
    { id: 'hasShipment', value: 'App.FiltersDrawer.Filters.HasShipment' },
    { id: 'hasQrDropoff', value: 'App.FiltersDrawer.Filters.HasQrDropoff' },
  ],
  selected: [],
};

export function buildLocationsFilterConfig(
  supportedCouriers: string[]
): Map<number, FilterOption> {
  return new Map([
    [MobileFilterType.Toggle, { ...LOCATIONS_TOGGLE_OPTIONS, selected: [] }],
    [
      MobileFilterType.CourierText,
      {
        options: supportedCouriers.map((courier) => ({ id: courier, value: courier })),
        selected: [],
      },
    ],
  ]);
}
